import {ImplicitFlowService} from "./ImplicitFlowService";
import {env} from "core/env";
import {HandleServiceError} from "decorators/service";
import {getMockRateSummary} from "mocks/rateSummaryMocks";
import {OwnerSummaryAttributes, RateSummaryAttributes} from "typing/dto";

export class GenAIService extends ImplicitFlowService {
    private static baseUrl = env.REACT_APP_GENAI_SERVICE_URL;
    private static service: GenAIService;

    constructor() {
        super(GenAIService.baseUrl);
    }

    /**
     * Get Singleton Instance
     */
    public static getInstance(): GenAIService {
        if (!GenAIService.service) {
            GenAIService.service = new GenAIService();
        }
        return GenAIService.service;
    }

    /**
     * Get Owner Summary
     */
    @HandleServiceError()
    public async getOwnerSummaryByUnitId(legacyUnitId: number): Promise<OwnerSummaryAttributes | null> {
        const axios = await this.axiosInstance();
        const {data: response} = await axios.get(`${this.apiUrl}/owner-summary/v2/lookup/${legacyUnitId}`);
        return response;
    }

    public async getRateSummaryByUnitId(unitId: number): Promise<RateSummaryAttributes> {
        // Mock data
        return getMockRateSummary(unitId);
    }
}
